/**
 * Shared UI flow for per-row competitor sync (Places profile vs Gemini AI rate).
 */

export async function runCompetitorRowSync({
  competitorId,
  syncFn,
  setBusyId,
  notifySuccess,
  notifyError,
  setCompetitorHotels,
  fetchCompetitorList,
  competitorSubTab,
  successMessage,
  errorFallback,
}) {
  if (competitorId == null) return;
  setBusyId(competitorId);
  try {
    const updated = await syncFn(competitorId);
    setCompetitorHotels((prev) =>
      prev.map((row) => (row.id === competitorId ? { ...row, ...updated } : row)),
    );
    notifySuccess?.(successMessage);
    if (competitorSubTab === 1) fetchCompetitorList();
  } catch (err) {
    notifyError?.(err?.error || err?.message || errorFallback);
  } finally {
    setBusyId(null);
  }
}
